import React from "react";

const UpdateAttendee = ({ formData, setFormData, handleChange, handleSubmit,onCancel, loading, error }) => {
  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Update Attendee</h2>

      {loading && <p className="text-blue-500 mb-4">Updating...</p>}
      {error && <p className="text-red-500 mb-4">{error}</p>}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-gray-700 font-medium">Slug</label>
          <input
            type="text"
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="e.g., webinar-1"
            required
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Title</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="e.g., Event Attendees"
            required
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Description</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            className="border w-full p-2"
            rows="3"
            placeholder="Enter attendee description..."
            required
          ></textarea>
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Attendees</label>
          <input
            type="text"
            name="attendees"
            value={formData.attendees}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="e.g., 500"
          />
        </div>

         <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={onCancel}
              className="bg-gray-500 text-white px-6 py-2 rounded hover:bg-gray-600"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              disabled={loading}
            >
              {loading ? "Updating..." : "Update Attendee"}
            </button>
          </div>
      </form>
    </div>
  );
};

export default UpdateAttendee;